module.exports = __webpack_public_path__ + "img/table.b709cb1d.jpg";